'use strict';

exports.__esModule = true;
exports.SocialLinks = exports.Links = exports.Box = exports.Container = exports.Wrapper = undefined;

var _templateObject = _taggedTemplateLiteralLoose(['\n  /* Design Quick Wins 2026-06 \u2014 Footer auf die Marke (Option A: Navy-Band).\n     Vorher: hartcodiertes Schwarz/Himmelblau komplett au\xDFerhalb der Token-Palette. */\n  color: ', ';\n  background-color: ', ';\n  border-top: 3px solid ', ';\n  z-index: 0;\n'], ['\n  /* Design Quick Wins 2026-06 \u2014 Footer auf die Marke (Option A: Navy-Band).\n     Vorher: hartcodiertes Schwarz/Himmelblau komplett au\xDFerhalb der Token-Palette. */\n  color: ', ';\n  background-color: ', ';\n  border-top: 3px solid ', ';\n  z-index: 0;\n']),
    _templateObject2 = _taggedTemplateLiteralLoose(['\n  max-width: 1140px;\n  width: auto;\n  margin: 0 auto;\n  display: flex;\n  justify-content: space-between;\n  padding: ', ';\n  background-color: ', ';\n  h3 {\n    font-size: 15px;\n    margin-bottom: 0px;\n  }\n  @media ', ' {\n    flex-direction: column;\n    padding: ', ';\n    h3 {\n      margin-top: ', ';\n    }\n  }\n'], ['\n  max-width: 1140px;\n  width: auto;\n  margin: 0 auto;\n  display: flex;\n  justify-content: space-between;\n  padding: ', ';\n  background-color: ', ';\n  h3 {\n    font-size: 15px;\n    margin-bottom: 0px;\n  }\n  @media ', ' {\n    flex-direction: column;\n    padding: ', ';\n    h3 {\n      margin-top: ', ';\n    }\n  }\n']),
    _templateObject3 = _taggedTemplateLiteralLoose(['\n  ', ';\n  ', ';\n'], ['\n  ', ';\n  ', ';\n']),
    _templateObject4 = _taggedTemplateLiteralLoose(['\n  @media ', ' {\n    padding-top: 0px;\n  }\n  li {\n    margin-top: ', ';\n    a {\n      color: ', ';\n      font-size: 13px;\n      font-weight: 400;\n    }\n    a:hover {\n      color: ', ';\n      text-decoration: underline;\n    }\n  }\n'], ['\n  @media ', ' {\n    padding-top: 0px;\n  }\n  li {\n    margin-top: ', ';\n    a {\n      color: ', ';\n      font-size: 13px;\n      font-weight: 400;\n    }\n    a:hover {\n      color: ', ';\n      text-decoration: underline;\n    }\n  }\n']),
    _templateObject5 = _taggedTemplateLiteralLoose(['\n  display: flex;\n  margin-left: -5px;\n  flex-wrap: wrap;\n  max-width: 150px;\n  padding-top: ', ';\n  li {\n    margin: ', ';\n  }\n'], ['\n  display: flex;\n  margin-left: -5px;\n  flex-wrap: wrap;\n  max-width: 150px;\n  padding-top: ', ';\n  li {\n    margin: ', ';\n  }\n']);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _device = require('../../styles/device');

var _spacing = require('../../styles/spacing');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }

var Wrapper = exports.Wrapper = _styledComponents2.default.footer(_templateObject, function (_ref) {
  var theme = _ref.theme;
  return theme.white;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.secondary;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.secondaryLight;
});

var Container = exports.Container = _styledComponents2.default.div(_templateObject2, (0, _spacing.space)(50, 20, 40), function (_ref4) {
  var theme = _ref4.theme;
  return theme.secondary;
}, _device.device.mobile, (0, _spacing.space)(10, 50, 40), (0, _spacing.space)(30));

var Box = exports.Box = _styledComponents2.default.div(_templateObject3, function (_ref5) {
  var withHeader = _ref5.withHeader;
  return !withHeader && 'padding-top: 22px';
}, function (_ref6) {
  var isLanguagesContainer = _ref6.isLanguagesContainer;
  return isLanguagesContainer && 'padding-top: 40px';
});

var Links = exports.Links = _styledComponents2.default.ul(_templateObject4, _device.device.mobile, (0, _spacing.space)(20), function (_ref7) {
  var theme = _ref7.theme;
  return theme.textColorD8;
}, function (_ref8) {
  var theme = _ref8.theme;
  return theme.white;
});

var SocialLinks = exports.SocialLinks = _styledComponents2.default.ul(_templateObject5, (0, _spacing.space)(20), (0, _spacing.space)(5));